const atom = require('recoil').atom;

module.exports = {
  value: atom({
    key: 'userState',
    default: {
      id: null,
      first_name: null,
      last_name: null,
      email: null,
    }
  })
};
